import type { PsHttpSSE } from '@patsnap-utils/sse';
import { FactoryPsHttpSSE } from '@patsnap-utils/sse';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface VisualReportEventData {
    content: string;
    status: string;
}

export interface VisualReportApi {
    getVisualReportStream(params: { text: string; isLogin: boolean; refresh_cache?: boolean }): PsHttpSSE<VisualReportEventData>;
}

export const VisualReportApi = Symbol('VisualReportApi');

@injectable()
export class VisualReportApiImpl extends PsHttpService implements VisualReportApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_SYNAPSE_URI}/api/ai-service`,
            baseURLGuest: `${import.meta.env.VITE_SYNAPSE_URI}/api/ai-service/guest`,
        };
    }

    @inject(FactoryPsHttpSSE)
    private _factorySsePsHttp!: FactoryPsHttpSSE;

    private getBaseURL(isLogin: boolean): string {
        return isLogin ? this.options.baseURL : this.options.baseURLGuest;
    }

    getVisualReportStream({ text, isLogin, refresh_cache }: { text: string; isLogin: boolean; refresh_cache?: boolean }) {
        return this._factorySsePsHttp<VisualReportEventData>()
            .init({
                url: `${this.getBaseURL(isLogin)}/pia/visual_report/stream`,
                data: { text, refresh_cache },
                hasFinalMessage: () => true,
            });
    }
}
